import { Stack, Tag } from '@optimus-web/core';
import { Bill, CorrectionType } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { BillStateTag } from '../../../../../components';
import { BillRebatedTag } from '../../../../billing/rebate';

interface Props {
    bill: Bill;
}

export const BillStatusCell = ({ bill }: Props) => {
    const rebatedTag =
        bill.correctionType && bill.correctionType === CorrectionType.CreditNote ? null : (
            <BillRebatedTag billId={bill.id} />
        );
    return (
        <Stack vertical spacing="25" itemAlignment="start">
            <BillStateTag bill={bill} />
            {bill.isCredited ? <Tag variant="tangerine">{lt('Credited')}</Tag> : rebatedTag}
            {bill.isSent ? <Tag variant="basicBold">{lt('Sent')}</Tag> : null}
        </Stack>
    );
};
